import { render } from "./PointContainer.vue?vue&type=template&id=080c88a2&scoped=true"
import script from "./PointContainer.vue?vue&type=script&lang=js"
export * from "./PointContainer.vue?vue&type=script&lang=js"

import "./PointContainer.vue?vue&type=style&index=0&id=080c88a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080c88a2"]])

export default __exports__